export const EASE = [0.22, 1, 0.36, 1];

export const viewportOnce = { once: true, amount: 0.15 };

export const fadeUp = {
    hidden: { opacity: 0, y: 28 },
    show: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.9, ease: EASE },
    },
};

export const fadeUpSlow = {
    hidden: { opacity: 0, y: 44 },
    show: {
        opacity: 1,
        y: 0,
        transition: { duration: 1.15, ease: EASE },
    },
};

export const stagger = {
    hidden: {},
    show: { transition: { staggerChildren: 0.12 } },
};

export const lineMask = {
    hidden: { y: "112%" },
    show: (i) => ({
        y: "0%",
        transition: { duration: 1.05, ease: EASE, delay: 0.18 + i * 0.14 },
    }),
};

export const maskContainer = {
    hidden: {},
    show: {
        transition: { delayChildren: 0.1, staggerChildren: 0.16 },
    },
};

export const maskLine = {
    hidden: { y: "112%" },
    show: {
        y: "0%",
        transition: { duration: 1.05, ease: EASE },
    },
};
